import { useEffect, useState } from "react";
import { normalize } from "@helpers";

const useSearch = <Type>(
  items: Array<Type>,
  params: {
    searchQuery: string;
    searchFields: string[];
  }
): [
  filteredItems: Array<Type>,
  setFilteredItems: React.Dispatch<React.SetStateAction<Type[]>>
] => {
  const { searchQuery, searchFields } = params;

  const [originalItems, setOriginalItems] = useState<Array<Type>>(items);
  const [filteredItems, setFilteredItems] = useState<Array<Type>>(items);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredItems = originalItems.filter((item: any) => {
      return searchFields.some(
        (field) =>
          item[field] && normalize(item[field]).includes(normalize(searchQuery))
      );
    });
    setFilteredItems(filteredItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalItems, searchQuery]);

  return [filteredItems, setOriginalItems];
};

export default useSearch;
